import * as React from "react"

const MainSection = ({ backgroundColor, props,children }) => {
	return (
		<div className={`mx-auto ${backgroundColor} p-20 sm:p-0 xxs:p-0 lg:p-20 md:p-20 ${props}`}>
			{children}
		</div>
	)
}

MainSection.defaultProps = {
	backgroundColor: 'bg-transparent',
	props: ''
};

export default MainSection
